import { useRoutes } from "react-router-dom";
import router from "src/router";
import { CssBaseline } from "@mui/material";
import ThemeProvider from "./theme/ThemeProvider";
import "./content/pages/homepage.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import SuspenseLoader from "./components/SuspenseLoader/SuspenseLoader";
import Footer from "./components/Footer/Footer";
import "./App.css";

function App() {
  const content = useRoutes(router);
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <SuspenseLoader />;
  }

  return (
    <ThemeProvider>
      <CssBaseline />
      <div className="appContainer">
        <div className="content">{content}</div>
        {/* Footer */}
        <Footer />
      </div>
    </ThemeProvider>
  );
}
export default App;
